import { initSlider } from './initSlider';

const swiperContainerClass = '.slider';
const sliderLength = document.querySelectorAll(swiperContainerClass).length;
let swipers = [];
let width = window.innerWidth;

function choiceInitSlider() {
  swipers.forEach((swiper) => {
    swiper.destroy(true, true);
  });

  swipers = [];

  setTimeout(() => {
    if (sliderLength > 1) {
      swipers = initSlider(swiperContainerClass);
    } else {
      swipers.push(initSlider(swiperContainerClass));
    }
  }, 1000);
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds/slider', () => {
      initSlider(swiperContainerClass);
    });
  } else {
    choiceInitSlider();
  }
});

window.addEventListener('resize', () => {
  if (window.innerWidth !== width) {
    width = window.innerWidth;

    swipers.forEach((swiper) => {
      swiper.destroy(true, true);
    });

    swipers = [];
    choiceInitSlider();
  }
});
